import type { ChatSessionDto } from '@/lib/api/sessions.client';
import type { IChatHistory } from '@/lib/types/chat';

/**
 * One row of a chat list from a session of the API. Every chat list maps its
 * rows here, so the plain sidebar, an agent's or a project's panel, the
 * project page and the search agree on what a row says.
 *
 * The server decides which list a chat belongs in and in what order; the row
 * only carries it. A chat without a message is dated by its creation.
 */
export const sessionToHistory = (session: ChatSessionDto): IChatHistory => {
  const createdAt = session.createdAt ?? new Date().toISOString();
  return {
    id: session.id,
    title: session.title,
    createdAt,
    lastMessageAt: session.lastMessageAt ?? createdAt,
    agentId: session.agentId ?? null,
    agentName: session.agentName ?? null,
    projectId: session.projectId ?? null,
    userId: session.userId ?? null,
    isPinned: session.isPinned ?? false,
    isShared: session.isShared ?? false,
    ownedByOther: session.ownedByOther ?? false,
    ownerName: session.ownerName ?? null,
    preview: session.preview ?? null,
    metadata: session.metadata ?? null,
    isArchived: session.isArchived ?? false,
  };
};
